<template>
  <div class="banner">
    <img :src="bannerImg" alt  class="bannerImg"/>

  </div>
</template>

<script>
export default {
  name: "banner",
  props: {
      bannerImg: {
          type:String,
          default:''
      },
      bannerImg1: {
          type:String,
          default:''
      },
      wenziImg: {
          type:String,
          default:''
      },
      wenziImg1: {
          type:String,
          default:''
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 14rem;
position: relative;
  .bannerImg {
        width: 100%;

  }
  .banner_text {
    position: absolute;
    top: 0;
    padding-top:1.71rem ;
    z-index: 1000;
    width: 12rem;
    left: 50%;
    margin-left:-6rem ;
  
    .wenzi{
        margin-bottom: 0.4rem;
        width: 5.94rem;
        margin: 0 auto;
        img{
          width: 100%;
        }
    }
    .wenzi1{
        margin-bottom: 0.4rem;
         width: 100%;
         
        img{
          width: 100%;
        }
    }
    .wenzi2{
    
        font-size: 0.34rem;
        line-height: 0.6rem;
        color: #FBF5B8;
        font-family: Source Han Sans SC;
      text-align: left;
    }
  }

}
</style>
